import { RestaurantCartItem } from "@/models/cart/types";
import { ScanToOrderCartItem } from "./scanToOrderCartItem/scanToOrderCartItem";

export interface CurrentItemsSectionProps {
  cartItems: RestaurantCartItem[];
  // eslint-disable-next-line no-unused-vars
  removeFromCart: (event: React.MouseEvent, index: number) => void;
  onRequestClose: () => void;
}

export const CurrentItemsSection = ({
  cartItems,
  removeFromCart,
  onRequestClose,
}: CurrentItemsSectionProps) => {
  return (
    <div className="pt-11 px-4 w-full">
      {cartItems?.map((item: RestaurantCartItem, index: number) => (
        <ScanToOrderCartItem
          key={index}
          index={index}
          item={item.value}
          removeFromCart={removeFromCart}
          onRequestClose={onRequestClose}
          isAlreadySentToKitchen={false}
        />
      ))}
    </div>
  );
};
